import { Grid, Typography } from '@mui/material';
import { Surface } from '../../../components/primitives';
import ChartSection from '../shared/ChartSection';
import { fmtPct } from '../shared/formatters';

export default function PostBuyTrajectory({ data }) {
    if (!data || Object.keys(data).length === 0) return null;

    const tiers = [
        { key: 'top', label: 'A-Rated Traders', color: 'success.main', desc: 'Top-graded members with proven information edge' },
        { key: 'all', label: 'All Members', color: 'primary.light', desc: 'Average across all Congress members' },
        { key: 'low', label: 'Low-Rated Traders', color: 'error.main', desc: 'C/D/F-graded members' },
    ];

    return (
        <ChartSection id="post-buy" title="What happens after skilled Congress members buy a stock?" subtitle="Average 1-year return after a congressional purchase, grouped by trader grade tier" takeaway={data.top && data.low ? `A-rated traders average ${fmtPct(data.top.avg_return)} returns after buying, while low-rated traders average ${fmtPct(data.low.avg_return)} — suggesting that trader skill, not just being in Congress, is what drives outperformance.` : null}>
            <Grid container spacing={2}>
                {tiers.map(tier => {
                    const d = data[tier.key];
                    if (!d) return null;
                    return (
                        <Grid item xs={12} md={4} key={tier.key}>
                            <Surface variant="subtle" padding={2.5}>
                                <Typography variant="body1" sx={{ color: tier.color, fontWeight: 700, mb: 1 }}>
                                    {tier.label}
                                </Typography>
                                <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, fontFamily: t => t.typography.fontFamilyMono, color: d.avg_return >= 0 ? 'success.main' : 'error.main' }}>
                                    {fmtPct(d.avg_return)} avg return
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.muted', display: 'block' }}>
                                    Median: {fmtPct(d.median_return)} · {d.positive_pct}% profitable · {d.count.toLocaleString()} trades
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.muted' }}>
                                    {tier.desc}
                                </Typography>
                            </Surface>
                        </Grid>
                    );
                })}
            </Grid>
        </ChartSection>
    );
}
